export default "/images/chat.svg?325bdace78c7bd03ac79a385a1398153";